<section style="padding-top: 1rem;"
  class="uk-section uk-container uk-container-medium uk-margin-medium-bottom +text-read">

  <div class="landing-body">
    <div class="header">
      <div [class]="classTab[0]" (click)="clickTab(1)">
        เงื่อนไขการเข้าร่วมโครงการประกันภัย
      </div>
      <div [class]="classTab[1]" (click)="clickTab(2)">
        สิทธิ์ประโยชน์สำหรับลูกค้า
      </div>
    </div>
    <div class="content" *ngIf="current==1">
      <div class="landing-center">
        <h1 class="uk-h2">{{ header }}</h1>
        <p class="uk-h4 uk-margin-remove">({{ subHeader }})</p>
      </div>
      <ol *ngIf="comcode == 'mazda'">
        <li>
          โครงการประกันภัยมาสด้าพรีเมี่ยมอินชัวรันส์ (MAZDA PREMIUM INSURANCE) ("โครงการ") เป็นโครงการ
          ร่วมกันระหว่าง บริษัท มาสด้า เซลส์ (ประเทศไทย) (“มาสด้า”) ซึ่งเป็นบริษัทผู้ผลิตและจัดจำหน่ายรถยนต์ กับ
          ธนาคารทิสโก้ จำกัด (มหาชน) (“ธนาคาร”) ในฐานะนายหน้าประกันภัย เพื่อนำเสนอผลิตภัณฑ์ประกันภัย
          รถยนต์จากบริษัทประกันภัยชั้นนำ พร้อมให้บริการแนะนำการเข้าซ่อมโดยศูนย์ซ่อมตัวถังและสีที่ได้รับการ
          รับรองมาตรฐานจากบริษัท มาสด้า เซลส์ (ประเทศไทย) จำกัด ทั่วประเทศ รวมถึงบริการที่เกี่ยวเนื่อง
        </li>
        <li>
          ผู้เข้าร่วมโครงการจะต้องเป็นผู้ขอเอาประกันตามกรมธรรม์ประกันภัยรถยนต์มาสด้า ที่โครงการกำหนด และ
          รถยนต์คันดังกล่าวต้องเป็นรถยนต์ในนามบุคคลเท่านั้น
        </li>
        <li>
          ผู้เข้าร่วมโครงการสามารถลงทะเบียน/สมัครเข้าร่วมโครงการ ได้ด้วยเลขประจำตัวประชาชน โดยไม่จำกัด
          จำนวนรถยนต์มาสด้า ของผู้ใช้บริการในโครงการ
        </li>
        <li>
          ในการตกลงเข้าร่วมโครงการ ผู้เข้าร่วมโครงการจะได้รับบริการ ดังต่อไปนี้
          <ol>
            <li>
              บริการให้คำแนะนำสิทธิประโยชน์และความคุ้มครองตามสัญญาประกันภัย รวมถึงการจัดให้มีการทำ
              สัญญาประกันภัยรถยนต์ และบริการอื่น ๆ ที่เกี่ยวเนื่อง เช่น บริการให้คำปรึกษาและประสานงานด้าน
              การเรียกร้องค่าสินไหมทดแทน บริการแนะนำศูนย์บริการซ่อมตัวถังและสีตามสิทธิประโยชน์ของ
              โครงการ โดยมีธนาคารเป็นผู้ให้บริการในปีแรก
            </li>
            <li>
              บริการดูแลการต่ออายุสัญญาประกันภัยรถยนต์ เพื่อให้ผู้เข้าร่วมโครงการได้รับความคุ้มครองอย่างต่อ
              เนื่อง รวมถึงบริการอื่น ๆ ที่เกี่ยวเนื่อง ตามที่ระบุในข้อ 4.1 โดย บริษัท ทิสโก้ อินชัวรันส์ โซลูชั่น
              จำกัด ซึ่งเป็นบริษัทในกลุ่มธุรกิจทางการเงินทิสโก้
            </li>
            <li>
              บริการซ่อมตัวถังและสีโดยศูนย์ซ่อมที่ได้รับการรับรองมาตรฐานจากมาสด้า พร้อมรับประกันการซ่อมสี
              นานสูงสุด 1 ปี และรับประกันอะไหล่ซ่อมนานสูงสุด 1 ปี หรือ 20,000 กิโลเมตร โดยเงื่อนไขการเข้า
              ซ่อม เป็นไปตามความคุ้มครองที่ระบุในกรมธรรม์
            </li>
          </ol>
        </li>
        <li>
          ผู้เข้าร่วมโครงการสามารถเข้าร่วมโครงการนี้ได้ต่อเนื่องสูงสุด 5 ปี ขึ้นอยู่กับอายุการจดทะเบียนรถยนต์
        </li>
        <li>
          สิทธิการรับบริการตามโครงการนี้จะสิ้นสุดเมื่อกรมธรรม์ประกันภัยรถยนต์ครบกำหนดอายุ และผู้เข้าร่วมโครงการ
          ไม่ได้ต่ออายุประกันภัยรถยนต์
        </li>
        <li>
          เพื่อให้ผู้เข้าร่วมโครงการได้รับบริการตามโครงการอย่างมีประสิทธิภาพ ธนาคาร และ ผู้ให้บริการในโครงการ
          ซึ่งหมายถึง บริษัท ทิสโก้ อินชัวรันส์ โซลูชั่น จำกัด ศูนย์บริการซ่อมตัวถังและสี บริษัทผู้ผลิตและจัดจำหน่าย
          รถยนต์ และตัวแทนจำหน่ายรถยนต์ มีความจำเป็นที่จะต้องเก็บรวบรวม และใช้ข้อมูลส่วนบุคคลของผู้เข้าร่วม
          โครงการ ตามที่ได้ให้ไว้ในการลงทะเบียน/สมัครเข้าร่วมโครงการ หรือที่ผู้เข้าร่วมโครงการจะได้ให้ในระหว่าง
          โครงการ รวมถึงเปิดเผย และ/หรือแลกเปลี่ยนข้อมูลส่วนบุคคลของผู้เข้าร่วมโครงการ ระหว่างธนาคาร ผู้ให้
          บริการในโครงการ และบริษัทผู้รับประกันภัยตามโครงการเพื่อการดำเนินการที่จำเป็นในการให้บริการและ/หรือ
          ผลิตภัณฑ์ที่เกี่ยวเนื่องกับโครงการ โดยข้อมูลส่วนบุคคลของผู้เข้าร่วมโครงการจะถูกเก็บไว้เป็นระยะเวลาสูงสุด
          5 ปี ขึ้นอยู่กับอายุการจดทะเบียนรถยนต์ หรือจนกว่าจะสิ้นสุดระยะเวลาดำเนินการตามกระบวนการเรียกร้องค่า
          สินไหมตามเงื่อนไขของกรมธรรม์ประกันภัยรถยนต์ ระยะเวลาใดระยะเวลาหนึ่งที่ยาวกว่า ทั้งนี้ ผู้เข้าร่วม
          โครงการสามารถศึกษารายละเอียดการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของธนาคารได้ที่
          <a href="https://www.tisco.co.th/th/privacy-notice.html">www.tisco.co.th/th/privacy-notice.html</a>
        </li>
      </ol>

      <ol *ngIf="comcode == 'ford'">
        <li>
          โครงการประกันภัยฟอร์ดเอนชัวร์ ( Ford Ensure) (&quot;โครงการ&quot;) เป็นโครงการร่วมกันระหว่าง บริษัท
          ฟอร์ด เซลส์ แอนด์ เซอร์วิส (ประเทศไทย) จำกัด (ฟอร์ด) ซึ่งเป็นบริษัทผู้ผลิตและจัดจำหน่ายรถยนต์
          กับธนาคารทิสโก้ จำกัด (มหาชน) (“ธนาคาร”) ในฐานะนายหน้าประกันภัย
          เพื่อนำเสนอผลิตภัณฑ์ประกันภัยรถยนต์จากบริษัทประกันภัยชั้นนำ
          พร้อมให้บริการแนะนำการเข้าซ่อมโดยศูนย์ซ่อมสีและตัวถังที่ได้รับการรับรองมาตรฐานจาก บริษัท ฟอร์ด
          เซลส์ แอนด์ เซอร์วิส (ประเทศไทย) จำกัด ทั่วประเทศ รวมถึงบริการที่เกี่ยวเนื่อง
        </li>
        <li>
          ผู้เข้าร่วมโครงการจะต้องเป็นผู้ขอเอาประกันตามกรมธรรม์ประกันภัยรถยนต์ฟอร์ด ที่โครงการกำหนด
          และรถยนต์คันดังกล่าวต้องเป็นรถยนต์ในนามบุคคลเท่านั้น
        </li>
        <li>
          ผู้เข้าร่วมโครงการสามารถลงทะเบียน/สมัครเข้าร่วมโครงการ ได้ด้วยเลขประจำตัวประชาชน โดยไม่จำกัด
          จำนวนรถยนต์ฟอร์ด ของผู้ใช้บริการในโครงการ
        </li>
        <li>
          ในการตกลงเข้าร่วมโครงการ ผู้เข้าร่วมโครงการจะได้รับบริการ ดังต่อไปนี้
          <ol>
            <li>
              บริการให้คำแนะนำสิทธิประโยชน์และความคุ้มครองตามสัญญาประกันภัย
              รวมถึงการจัดให้มีการทำสัญญาประกันภัยรถยนต์ และบริการอื่น ๆ ที่เกี่ยวเนื่อง เช่น
              บริการให้คำปรึกษาและประสานงานด้านการเรียกร้องค่าสินไหมทดแทน
              บริการแนะนำศูนย์บริการซ่อมสีและตัวถังสิทธิประโยชน์ของโครงการ
              โดยมีธนาคารเป็นผู้ให้บริการในปีแรก
            </li>
            <li>
              บริการดูแลการต่ออายุสัญญาประกันภัยรถยนต์
              เพื่อให้ผู้เข้าร่วมโครงการได้รับความคุ้มครองอย่างต่อเนื่อง รวมถึงบริการอื่น ๆ ที่เกี่ยวเนื่อง
              ตามที่ระบุในข้อ 4.1 โดย บริษัท ทิสโก้ อินชัวรันส์ โซลูชั่น จำกัด
              ซึ่งเป็นบริษัทในกลุ่มธุรกิจทางการเงินทิสโก้
            </li>
            <li>
              บริการซ่อมสีและตัวถังโดยศูนย์ซ่อมที่ได้รับการรับรองมาตรฐานจากฟอร์ด
              พร้อมรับประกันการซ่อมสีนานสูงสุด 1 ปี และรับประกันอะไหล่ซ่อมนานสูงสุด 1 ปี หรือ 20,000
              กิโลเมตร โดยเงื่อนไขการเข้าซ่อม เป็นไปตามความคุ้มครองที่ระบุในกรมธรรม์
            </li>
          </ol>
        </li>
        <li>
          ผู้เข้าร่วมโครงการสามารถเข้าร่วมโครงการนี้ได้ต่อเนื่องสูงสุด 7 ปี ขึ้นอยู่กับอายุการจดทะเบียนรถยนต์
        </li>
        <li>
          สิทธิการรับบริการตามโครงการนี้จะสิ้นสุดเมื่อกรมธรรม์ประกันภัยรถยนต์ครบกำหนดอายุ
          และผู้เข้าร่วมโครงการไม่ได้ต่ออายุประกันภัยรถยนต์
        </li>
        <li>
          เพื่อให้ผู้เข้าร่วมโครงการได้รับบริการตามโครงการอย่างมีประสิทธิภาพ ธนาคาร และ
          ผู้ให้บริการในโครงการ ซึ่งหมายถึง บริษัท ทิสโก้ อินชัวรันส์ โซลูชั่น จำกัด ศูนย์บริการซ่อมสีและตัวถัง
          บริษัทผู้ผลิตและจัดจำหน่ายรถยนต์ และตัวแทนจำหน่ายรถยนต์ มีความจำเป็นที่จะต้องเก็บรวบรวม
          และใช้ข้อมูลส่วนบุคคลของผู้เข้าร่วมโครงการ ตามที่ได้ให้ไว้ในการลงทะเบียน/สมัครเข้าร่วมโครงการ
          หรือที่ผู้เข้าร่วมโครงการจะได้ให้ในระหว่างโครงการ รวมถึงเปิดเผย
          และ/หรือแลกเปลี่ยนข้อมูลส่วนบุคคลของผู้เข้าร่วมโครงการ ระหว่างธนาคาร ผู้ให้บริการในโครงการ
          และบริษัทผู้รับประกันภัยตามโครงการเพื่อการดำเนินการที่จำเป็นในการให้บริการและ/หรือผลิตภัณฑ์ที่เกี่
          ยวเนื่องกับโครงการ โดยข้อมูลส่วนบุคคลของผู้เข้าร่วมโครงการจะถูกเก็บไว้เป็นระยะเวลาสูงสุด 7 ปี
          ขึ้นอยู่กับอายุการจดทะเบียนรถยนต์
          หรือจนกว่าจะสิ้นสุดระยะเวลาดำเนินการตามกระบวนการเรียกร้องค่าสินไหมตามเงื่อนไขของกรมธรรม์ประ
          กันภัยรถยนต์ ระยะเวลาใดระยะเวลาหนึ่งที่ยาวกว่า ทั้งนี้
          ผู้เข้าร่วมโครงการสามารถศึกษารายละเอียดการเก็บรวบรวม ใช้
          และเปิดเผยข้อมูลส่วนบุคคลของธนาคารได้ที่ <a href="https://www.tisco.co.th/th/privacy-notice.html">www.tisco.co.th/th/privacy-notice.html</a>
        </li>
      </ol>
    </div>
    <div class="content" *ngIf="current==2">
      <img *ngIf="comcode=='mazda'" src="/contents/images/term_mazda.png">
      <img *ngIf="comcode=='ford'" src="/contents/images/term_ford.png">
    </div>
  </div>
</section>